import { CalendarEvent, LeaveRequest } from "../models/leaveModels";
import { addDays, groupConsecutiveDates } from "./dateUtils";

/**
 * Team-calendar entries for an approved request: one all-day entry per run of
 * consecutive leave days (end-exclusive), so Mon + Wed shows as two entries
 * rather than a Mon–Wed bar.
 */
export function requestToEvents(r: LeaveRequest): CalendarEvent[] {
  return groupConsecutiveDates(r.leaveDates).map((run, i) => ({
    id: `req-${r.id}-${i}`,
    subject: `${r.employee} — ${r.leaveTypeCode}`,
    start: `${run[0]}T00:00:00.000Z`,
    end: `${addDays(run[run.length - 1], 1)}T00:00:00.000Z`,
    leaveTypeCode: r.leaveTypeCode,
    employeeName: r.employee,
  }));
}

/** True when an event overlaps [startISO, endISO] (compared by calendar day). */
export function eventInWindow(e: CalendarEvent, startISO: string, endISO: string): boolean {
  return e.start.slice(0, 10) <= endISO.slice(0, 10) && e.end.slice(0, 10) > startISO.slice(0, 10);
}
